import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { DataService } from "src/app/services/data.service";
import { ElementRef, HostListener, ViewChild } from "@angular/core";
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  @ViewChild("autoSuggestion") autoSuggestion!: ElementRef;
  cateData: any = [];
  slidesData: any = [];
  illusData: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  visibleIllusData: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];   // rendered data
  pageSize = 20;
  currentPage = 1;
  isLoadingMore = false;

  collectionData: any = [];
  aiIllusData: any = [];
  illusPopularData: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  visiblePopularData: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  popularPageSize = 20;
  popularCurrentPage = 1;
  isPopularLoadingMore = false;

  exclusiveData: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  user: any = {};
  chiploading = true;


  constructor(
    private dataService: DataService,
    public router: Router,
    public authService: AuthService
  ) { }
  typeahead: FormControl = new FormControl();
  isMobile = window.innerWidth <= 576;
  searchKey = "Illustration";

  suggestions: string[] = [];
  loader = true;
  imageLoad = true;

  previousUserId = "";

  convertTitle(value) {
    return this.dataService.generateSlug(value);
  }

  getSEOImage(url: string): string {
    return buildSEOImageUrl(url);
  }

  suggest() {
    if (this.typeahead.value.length > 0) {
      this.searchKey == "Illustration"
        ? (this.suggestions = this.illusData.filter(
          (c) =>
            !c.isAIIllustration &&
            c.title.toLowerCase().includes(this.typeahead.value.toLowerCase())
        ))
        : this.searchKey == "Collections"
          ? (this.suggestions = this.collectionData
            .filter(
              (c) =>
                !c.isAICollection &&
                c.collectionName
                  .toLowerCase()
                  .includes(this.typeahead.value.toLowerCase())
            )
            .slice(0, 5))
          : this.searchKey == "AI Images"
            ? (this.suggestions = this.aiIllusData
              .filter(
                (c) =>
                  c.isAIIllustration &&
                  c.title
                    .toLowerCase()
                    .includes(this.typeahead.value.toLowerCase())
              )
              .slice(0, 5))
            : [];
    } else {
      this.suggestions = [];
    }
    // console.log(this.suggestions);
  }

  setSearchKey(data) {
    data == "illus"
      ? (this.searchKey = "Illustration")
      : data == "collect"
        ? (this.searchKey = "Collections")
        : data == "aiImage"
          ? (this.searchKey = "AI Images")
          : (this.searchKey = "");
  }

  async ngOnInit() {
    if (sessionStorage.getItem("returnUrl")) {
      sessionStorage.removeItem("returnUrl");
    }
    this.user = this.dataService.userDetail;
    (await this.dataService.getCategoryService()).subscribe((singleservice) => {
      this.cateData = [];
      this.cateData = singleservice.filter((c: any) => !c.isAICategory);
      this.chiploading = false;
    });

    if (this.user && this.user.id) {
      this.authService.checkSubscriptionStatus(this.user, true);
      this.previousUserId = this.user.id;
      this.dataService.userDetails();
      // window.location.reload();
    }
    (await this.dataService.getHomeBannerService()).subscribe(
      (singleservice) => {
        this.slidesData = [];
        this.slidesData = singleservice;
      }
    );
    (await this.dataService.getIllustrationService()).subscribe(
      (singleservice) => {
        // this.illusData = [];
        this.illusData = (singleservice || []).filter(
          (c: any) => !c.isAIIllustration);
        this.illusData = singleservice.filter((c: any) => !c.isAIIllustration);
        this.loader = false;
        this.imageLoad = false;
        this.initIllusLoad();   // ✅ after data assignment
      }
    );
    (await this.dataService.getAIIllustrationService()).subscribe(
      (singleservice) => {
        this.aiIllusData = [];
        this.aiIllusData = singleservice.filter((c: any) => c.isAIIllustration);
        this.loader = false;
        this.imageLoad = false;
      }
    );
    (await this.dataService.getIllustrationPopularService()).subscribe(
      (singleservice) => {
        // this.illusPopularData = [];
        // this.illusPopularData = singleservice.filter(
        //   (c: any) => !c.isAIIllustration
        // );
        this.illusPopularData = (singleservice || []).filter(
          (c: any) => !c.isAIIllustration);
        this.loader = false;
        this.imageLoad = false;
        this.initPopularLoad(); // ✅ important
      }
    );
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.collectionData = [];
        this.collectionData = singleservice;
        this.loader = false;
        this.imageLoad = false;
        //console.log(this.collectionData);
      }
    );

    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.exclusiveData = [];

        this.collectionData = [];
        this.collectionData = singleservice;
        // console.log(singleservice);
        for (let i = 0; i < singleservice.length; i++) {
          if (
            singleservice[i]["isExclusive"] &&
            this.exclusiveData.length < 5 &&
            !singleservice[i]["isAICollection"]
          ) {
            this.exclusiveData.push(singleservice[i]);
          }
        }
      }
    );
  }

  navigateTo() {
    if (!this.typeahead.value || this.typeahead.value.trim() === "") {
      return;
    }

    this.router.navigate(["/search"], {
      queryParams: { value: this.typeahead.value, searchKey: this.searchKey },
    });
    //console.log("enter pressed");
    this.suggestions = [];
    if (this.typeahead?.setValue) {
      this.typeahead.setValue("");
    }
  }

  @HostListener("document:click", ["$event"])
  handleClickOutside(event: MouseEvent) {
    const clickedInside = this.autoSuggestion?.nativeElement.contains(
      event.target
    );
    if (!clickedInside) {
      this.suggestions = [];
      if (this.typeahead?.setValue) {
        this.typeahead.setValue("");
      }
    }
  }

  onSuggestionClick(): void {
    this.suggestions = []; // Clears suggestions
    this.typeahead.setValue(""); // Optional: clears input value
  }


  initIllusLoad() {
    this.currentPage = 1;
    this.visibleIllusData = this.illusData.slice(0, this.pageSize);
  }

  loadMoreIllus() {
    this.isLoadingMore = true;

    setTimeout(() => {
      this.currentPage++;

      this.visibleIllusData = this.illusData.slice(
        0,
        this.currentPage * this.pageSize
      );

      this.isLoadingMore = false;
    }, 300);
  }

  get hasMoreIllus(): boolean {
    return this.visibleIllusData.length < this.illusData.length;
  }

  /* ---------- Popular Grid ---------- */

  initPopularLoad() {
    this.popularCurrentPage = 1;
    this.visiblePopularData = this.illusPopularData.slice(
      0,
      this.popularPageSize
    );
  }

  loadMorePopular() {
    this.isPopularLoadingMore = true;

    setTimeout(() => {
      this.popularCurrentPage++;

      this.visiblePopularData = this.illusPopularData.slice(
        0,
        this.popularCurrentPage * this.popularPageSize
      );

      this.isPopularLoadingMore = false;
    }, 300);
  }

  get hasMorePopular(): boolean {
    return this.visiblePopularData.length < this.illusPopularData.length;
  }


}
